import { Card, Col, Row } from 'antd'
import React from 'react'
import { FaChevronLeft } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import BusinessInfoForm from './BusinessInfoForm' 

const UpdateBusinessInfo = () => {
    return (
        <Row>
            <Col md={24} sm={24} xs={24} className="md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6">
                <div className='flex justify-between items-center mb-2'>
                    <h5 className='heading-5 text-slate-600 font-semibold'>Business Info</h5>
                    <Link to='/' className='cursor-pointer flex items-center'>
                        <FaChevronLeft className='text-primary bg-white p-2 rounded-full text-3xl' />
                        <small className='ml-2 font-medium'>Back</small>
                    </Link>
                </div>
                <Card bordered={false} className='p-0'>
                    <BusinessInfoForm/>
                </Card>
            </Col>
        </Row>
    )
}

export default UpdateBusinessInfo